import { MenuCard } from '@runway/devkit';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

export const AMLComputeInstance: FC = () => {
  const navigate = useNavigate();

  return (
    <MenuCard
      title="Azure Machine Learning Compute Instance"
      subtitle="Create a compute instance for a user in Azure Machine Learning"
      onButtonClick={() => navigate('/orion/aml-ci')}
      buttonText="Create"
    />
  );
};
